import { environment } from "../../environments";

export class ApiConstants {

    public static apiUrl = environment.apiUrl;
    public static zignFlixApiUrl = environment.zignFlixApiUrl;

    //AUTH API
    public static superAdminLogin: string = this.apiUrl + 'super-admin-login/';
    public static superAdminClearToken: string = this.apiUrl + 'super-admin-clear-token/';

    //JWT TOKEN API
    public static superAdminGenerateJwtToken: string = this.apiUrl + 'super-admin-generate-jwt-token/';

    //BUSINESS API
    public static superAdminBusiness: string = this.apiUrl + 'super-admin-business-detail/';
    public static superAdminBusinessEdit: string = this.apiUrl + 'super-admin-business-subscription/';
    public static superAdminBusinessDelete: string = this.apiUrl + 'super-admin-business-delete/';
    public static superAdminScreenDetails: string = this.apiUrl + 'super-admin-screen-details/';

    //INVOICE API
    public static superAdminCustomInvoice: string = this.apiUrl + 'super-admin-custom-invoice/';
    public static superAdminDownloadInvoice: string = this.apiUrl + 'super-admin-invoice-report/';
    public static superAdminSendInvoiceCopy: string = this.apiUrl + 'super-admin-invoice-send/'
    public static superAdminBusinessUsers: string = this.apiUrl + 'super-admin-business-user/';
    public static superAdminSendReceiptMail: string = this.apiUrl + 'super-admin-receipt-mail/';

    //BILLING ADDRESS API
    public static superAdminBillingAddress: string = this.apiUrl + 'super-admin-billing-address/';

    //COUNTRY STATE API
    public static countryStateApi: string = this.apiUrl + 'super-admin-country-state/';

    //WATERMARK SETTINGS API
    public static superAdminBusinessSettings: string = this.apiUrl + 'super-admin-business-setting/';

    //CONTENT API
    public static contents: string = this.apiUrl + 'super-admin-contents/';

    //PRESIGNED URL API
    public static presignedURLForS3: string = this.zignFlixApiUrl + 's3-upload/';

    //PLAYLIST API
    public static playlist: string = this.apiUrl + 'super-admin-compositions/';

    //CAMPAIGN API
    public static campaign: string = this.apiUrl + 'super-admin-screen-playlist/';

    //SCREENS API
    public static screens: string = this.apiUrl + 'super-admin-business-screen/';
    public static superAdminOOHScreens: string = this.apiUrl + 'ooh-screen-approval/';

}